// Этот сервис используется на новой форме поиска
angular.module('cian.geoService', [])
.factory('GeoService', ["$q", "$window", function($q, $window) {
  var service = {};

  service.getDistanceBetweenTwoPoints = function (point1, point2) {
    var lat1 = point1[1],
      lon1 = point1[0],
      lat2 = point2[1],
      lon2 = point2[0],
      R = 6371, //km
      dLat = (lat2 - lat1) * Math.PI / 180,
      dLon = (lon2 - lon1) * Math.PI / 180,
      a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2),
      c = 2 * Math.asin(Math.sqrt(a));

    return R * c;
  };

  service.getOptimalRadius = function(mapBounds) {
    var leftBottomPoint = mapBounds[0],
        leftTopPoint = [leftBottomPoint[0], mapBounds[1][1]],
        height = service.getDistanceBetweenTwoPoints(leftBottomPoint, leftTopPoint);

    return Math.floor(height / 5 * 1000);
  };

  service.getCoordinatesForCircleResizer = function(circle) {
    var x = circle.geometry.getBounds()[0][0],
        y = circle.geometry.getCoordinates()[1];

    return [x,y];
  };

  service.pagePixelsToGeoCoords = function(points, map) {
    var coords = [],
        projection = map.options.get('projection');

    for (var i = 0; i < points.length; i++) {
      coords.push(projection.fromGlobalPixels(
        map.converter.pageToGlobal(points[i]), map.getZoom()
      ));
    }

    return coords;
  };

  service.simplifyGeometry = function(geometry, map) {
    var kink = {
      '5': 25500,
      '6': 17500,
      '7': 8500,
      '8': 4400,
      '9': 2200,
      '10': 1000,
      '11': 400,
      '12': 250,
      '13': 100,
      '14': 50,
      '15': 20,
      '16': 10,
      '17': 5
    };

    return GDouglasPeucker(geometry,kink[Math.round(map.getZoom()).toString()]);
  };

  service.getPolygonGeometryFromMousePath = function(points, map) {
    var coords = service.pagePixelsToGeoCoords(points, map);
    return service.simplifyGeometry(coords, map);
  };

  return service;
}]);



// WEBPACK FOOTER //
// ./src/components/geo-service/src/scripts/cian.geoService.js